import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
// baseUrl
import { baseURL } from "utils/api";
import axios from "utils/api";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

function Index() {
  const [subjectName, setSubjectName] = useState("");
  const [selectedBoard, setSelectedBoard] = useState("");
  const [boards, setBoards] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  console.log("Subject ID from URL:", id);

  //get api se board ka data lana hai id ke sath input field mai show karne ke liye
  //aur fir update karne ke liye put api call karni hai

  useEffect(() => {
    // Fetch boards
    axios
      .get(`${baseURL}/boards`)
      .then((res) => {
        if (res.data.success) {
          setBoards(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching boards:", err);
        toast.error("Failed to load boards");
      });

    // Fetch subject details
    axios
      .get(`${baseURL}/subjects/${id}`)
      .then((res) => {
        console.log("Subject details:", res.data);
        if (res.data.success) {
          setSubjectName(res.data.data.name);
          setSelectedBoard(res.data.data.board?._id || res.data.data.board || "");
        }
      })
      .catch((err) => {
        console.error("Error fetching subject details:", err);
        toast.error("Failed to load subject details");
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!subjectName.trim()) {
      toast.error("Subject name cannot be empty");
      return;
    }
    if (!selectedBoard) {
      toast.error("Please select a board");
      return;
    }

    setLoading(true);
    console.log("Updating Subject:", subjectName, "Board:", selectedBoard);

    axios
      .put(`${baseURL}/subjects/${id}`, {
        name: subjectName,
        board: selectedBoard,
      })
      .then((response) => {
        console.log(response.data);
        toast.success(response.data?.message || "Subject updated successfully");
        navigate("/curriculum");
      })
      .catch((error) => {
        console.error("Error updating subject:", error);
        toast.error(
          error.response?.data?.error || error.response?.data?.message || "Failed to update subject"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card sx={{ p: 3, borderRadius: "16px", boxShadow: 3 }}>
            <ArgonTypography mb={1} variant="h5" fontWeight="bold">
              Edit Subject Name
            </ArgonTypography>
            <Divider sx={{ mb: 3 }} />

            <form onSubmit={handleSubmit}>
              <ArgonBox display="flex" flexDirection="column" gap={2}>
                {/* Board Dropdown */}
                <ArgonBox>
                  <FormControl fullWidth>
                    <InputLabel id="board-select-label">Select Board</InputLabel>
                    <Select
                      labelId="board-select-label"
                      id="board-select"
                      value={selectedBoard}
                      label="Select Board"
                      onChange={(e) => setSelectedBoard(e.target.value)}
                      sx={{ height: "45px" }}
                    >
                      <MenuItem value="">
                        <em>Select a board</em>
                      </MenuItem>
                      {boards.map((board) => (
                        <MenuItem key={board._id} value={board._id}>
                          {board.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </ArgonBox>

                {/* Subject Name Input */}
                <ArgonBox>
                  <ArgonInput
                    type="text"
                    placeholder="Enter Subject Name"
                    value={subjectName}
                    onChange={(e) => setSubjectName(e.target.value)}
                    fullWidth
                  />
                </ArgonBox>

                {/* Submit Button */}
                <ArgonBox>
                  <ArgonButton
                    color="primary"
                    type="submit"
                    variant="contained"
                    fullWidth
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update Subject"}
                  </ArgonButton>
                </ArgonBox>
              </ArgonBox>
            </form>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Index;
